import { openModal } from 'features/modal/modalSlice';
import {
  selectRestreamerStatus,
  selectRestreamingConsentMessageEnabled,
} from 'features/restreamer/restreamerSlice';
import { RestreamerStatus } from 'features/restreamer/types';
import { put, select } from 'redux-saga/effects';
import { restreamingToggled } from 'features/restreamer/actions';
import { selectE2eeEnabled } from 'features/e2ee/e2eeSlice';

export function* toggleRestreamingSaga(action: ReturnType<typeof restreamingToggled>) {
  const status: RestreamerStatus = yield select(selectRestreamerStatus);

  const targetState = action.payload;

  if (status === 'started') {
    if (targetState) {
      return;
    }

    yield put(openModal('stopRestreamingConfirmation'));

    return;
  }

  if (targetState !== undefined && !targetState) {
    return;
  }

  const consentEnabled: boolean = yield select(selectRestreamingConsentMessageEnabled);
  if (!consentEnabled) {
    yield put(openModal('restreamingConfig'));
    return;
  }

  const e2eeEnabled: boolean = yield select(selectE2eeEnabled);
  if (e2eeEnabled) {
    yield put(openModal('restreamingE2eeConsent'));
  } else {
    yield put(openModal('restreamingConsent'));
  }
}
